import * as React from 'react'

import { determineHandoverType } from '~logic/helpers/determineHandoverType'

import { OrderPlaceIconLine } from '../../../components/OrderInfo/OrderInfoIconLines'
import { useFormOrderCtx } from '../contexts/FormOrderProvider'

type TProps = RequiredChildren

/**
 * Order place with icon as presented on FormScreen.
 */
export const FormOrderPlaceIconLine: React.FC<TProps> = ({ children }) => {
  const order = useFormOrderCtx()

  const handoverType = order?.handoverType ? determineHandoverType(order.handoverType.enum) : null

  return <OrderPlaceIconLine handoverType={handoverType}>{children}</OrderPlaceIconLine>
}
